import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { GenericMenuComponent } from "../generic-menu-component.model";
import { MenuItem } from "../menu-item.model";

@Component({
  selector: "app-tiered-menu",
  templateUrl: "./tiered-menu.component.html",
  styleUrls: ["./tiered-menu.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TieredMenuComponent extends GenericMenuComponent {
  @Input() items: MenuItem[] = [];


  constructor(private readonly changeDetector: ChangeDetectorRef) {
    super();
  }


  onMouseLeave = (event): void => {
    setTimeout(() => { this.changeDetector.markForCheck(); }, 500);
  }
}
